import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import {
  BsBrowserChrome,
  BsGithub,
  BsYoutube,
  BsArrowLeft,
} from "react-icons/bs";
import { projects } from "../../data/projects-data";
import { ProjectSlideshow } from "../slideshow/ProjectSlideshow";
import Nav from "../nav/Nav";
import Footer from "../footer/Footer";
import "./project-details.css";

const ProjectDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  const project = projects.find((p) => p.id === parseInt(id));

  if (!project) {
    return (
      <>
        <Nav />
        <section className="project-details section-padding">
          <div className="container">
            <h2>Project not found</h2>
            <button className="btn" onClick={() => navigate("/projects")}>
              <BsArrowLeft /> Back to Projects
            </button>
          </div>
        </section>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Nav />
      <section className="project-details">
        <div className="container">
          <div className="project-details__content">
            <div className="project-details__header">
              <h1 className="project-details__title">{project.title}</h1>
              
              {/* Project Slideshow */}
              {project.images && project.images.length > 0 ? (
                <div className="project-details__slideshow">
                  <ProjectSlideshow
                    images={project.images}
                    title={project.title}
                    className="project-slideshow"
                  />
                </div>
              ) : (
                <div className="project-details__image">
                  <img src={project.image} alt={project.title} />
                </div>
              )}
            </div>

            <div className="project-details__info">
              <h3>{t("projectDetails.description-title")}</h3>
              <p className="project-details__description">
                {t(`projectDetails.description-content.${project.description}`)}
              </p>
              <div className="project-details__tech">
                <h3>{t("projectDetails.tech")}</h3>
                <div className="project-details__tech-stack d-flex justify-content-center">
                  {project.stack.map((tech, index) => (
                    <span key={index} className="tech-tag-large">
                      {tech}
                    </span>
                  ))}
                </div>
              </div>

              <div className="project-details__links">
                <h3>{t("projectDetails.links")}</h3>
                <div className="project-details__cta">
                  <a
                    className="btn"
                    href={project.github}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <BsGithub className="btn__icon" />
                  </a>
                  <a
                    className="btn"
                    href={project.demo}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <BsBrowserChrome className="btn__icon" />
                  </a>
                  <a
                    className="btn"
                    href={project.video}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <BsYoutube className="btn__icon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default ProjectDetails;
